import React from "react";
import { ChevronLeft, Store, Coins, Package, HelpCircle, House, Shirt } from "lucide-react";
import { pill, roundBtn, SAFE_TOP, GLASS, FONT, glassBox, glassInner } from "../kota/ui";

// Bar atas halaman Mall: ← kembali · pil "Mall Jawsel" · pil koin (pemegang KTW) · Barangku (badge jumlah) · ?
export function MallTopBar({ saldo, punya, onBack, onBarangku, onBantuan }) {
  return (
    <div data-testid="mall-topbar" style={{ position: "absolute", left: 12, right: 12, top: `calc(${SAFE_TOP} + 12px)`, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, pointerEvents: "none", fontFamily: FONT, zIndex: 6 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 8, minWidth: 0 }}>
        <button data-testid="mall-kembali" aria-label="Kembali" onClick={onBack} style={{ ...roundBtn(false), width: 38, height: 38, pointerEvents: "auto" }}><ChevronLeft size={18} strokeWidth={2} /></button>
        <div data-testid="mall-pill" style={{ ...pill, height: 46, padding: "0 14px 0 6px", gap: 8, minWidth: 0 }}>
          <span style={{ width: 34, height: 34, borderRadius: 99, background: GLASS.accentBg, color: GLASS.accent, display: "grid", placeItems: "center", flex: "none" }}><Store size={17} strokeWidth={2} /></span>
          <span style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", lineHeight: 1.1, minWidth: 0 }}>
            <b style={{ fontSize: 13, fontWeight: 800, letterSpacing: -0.2, whiteSpace: "nowrap" }}>Mall Jawsel</b>
            <span style={{ fontSize: 10.5, color: GLASS.sub, fontWeight: 700, whiteSpace: "nowrap" }}>Koleksi Studio Jawsel</span>
          </span>
        </div>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        {saldo != null && <span data-testid="mall-saldo" style={{ ...pill, height: 38, padding: "0 12px", gap: 6, fontWeight: 800 }}><Coins size={14} color="#d9a21b" /> {saldo}</span>}
        <button data-testid="mall-barangku" aria-label="Barangku" onClick={onBarangku} style={{ ...roundBtn(false), width: 38, height: 38, pointerEvents: "auto", position: "relative", overflow: "visible" }}>
          <Package size={17} strokeWidth={2} />
          {punya > 0 && <span data-testid="mall-barangku-badge" style={{ position: "absolute", top: -5, right: -5, minWidth: 18, height: 18, padding: "0 5px", borderRadius: 99, background: GLASS.accent, color: "#fff", fontSize: 10, fontWeight: 800, display: "grid", placeItems: "center", border: "2px solid #fff", boxSizing: "border-box" }}>{punya}</span>}
        </button>
        <button data-testid="mall-bantuan" aria-label="Petunjuk" onClick={onBantuan} style={{ ...roundBtn(false), width: 38, height: 38, pointerEvents: "auto" }}><HelpCircle size={17} strokeWidth={2} /></button>
      </div>
    </div>
  );
}

// Toggle bersegmen: Rumah (perabot) · Butik Avatar (aksesoris)
export function MallTabs({ aktif, onPilih }) {
  const items = [["rumah", "Rumah", House], ["aksesoris", "Butik Avatar", Shirt]];
  return (
    <div data-testid="mall-tabs" style={{ position: "absolute", left: 0, right: 0, top: `calc(${SAFE_TOP} + 68px)`, display: "flex", justifyContent: "center", pointerEvents: "none", fontFamily: FONT, zIndex: 6 }}>
      <div style={{ pointerEvents: "auto", display: "flex", gap: 2, padding: 4, ...glassBox, borderRadius: 99 }}>
        {items.map(([k, nama, Icon]) => {
          const on = aktif === k;
          return (
            <button key={k} data-testid={`mall-tab-${k}`} aria-pressed={on} onClick={() => onPilih(k)}
              style={{ height: 34, padding: "0 16px", borderRadius: 99, ...glassInner(on), color: on ? GLASS.accent : GLASS.ink, fontWeight: on ? 800 : 600, fontSize: 12.5, cursor: "pointer", fontFamily: FONT, whiteSpace: "nowrap", display: "inline-flex", alignItems: "center", gap: 6 }}>
              <Icon size={14} strokeWidth={2} /> {nama}
            </button>
          );
        })}
      </div>
    </div>
  );
}
